import axiosClient from "./axiosClient";
import { ApiResponse } from "models";

const groupApi = {
  getRegionWiseBrand(data: any): Promise<any> {
    const url = `/brand/getRegionWiseBrand?search=${data?.search || ""}`;
    return axiosClient.get(url);
  },
  getDevices(data: any): Promise<any> {
    const params: Record<string, string> = {};

    if (data.locationId) params.locationId = String(data.locationId);
    if (data.brandId) params.brandId = String(data.brandId);
    if (data.serialNumber) params.serialNumber = data.serialNumber;
    if (data.search) params.search = data.search;
    if (data.page) params.page = String(data.page);
    if (data.limit) params.limit = String(data.limit);
    if (data.country) params.country = data.country;

    const queryString = new URLSearchParams(params).toString();
    const url = `/deviceMapping/getDevices${
      queryString ? `?${queryString}` : ""
    }`;

    return axiosClient.get(url);
  },

  deleteDevice(data: any): Promise<ApiResponse> {
    const url = `/deviceMapping/deleteDevice?id=${data?.id}`;
    return axiosClient.delete(url);
  },

  updateDevice(data: any): Promise<ApiResponse> {
    const url = `/deviceMapping/updateDevice`;
    return axiosClient.put(url, data);
  },
  add(data: any): Promise<ApiResponse> {
    const url = `/deviceMapping/addDevice`;
    return axiosClient.post(url, data);
  },
  getDeviceById(id: string): Promise<ApiResponse> {
    const url = `/deviceMapping/getDeviceById?id=${id}`;
    return axiosClient.get(url);
  },
};

export default groupApi;
